import React from 'react'
import {Grid, useMediaQuery, useTheme} from '@material-ui/core'

export default React.memo(props => {

  function useWidth () {
    const theme = useTheme()
    const keys = [...theme.breakpoints.keys].reverse()
    return (
      keys.reduce((output, key) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const matches = useMediaQuery(theme.breakpoints.up(key))
        return !output && matches ? key : output
      }, null) || 'xs'
    )
  }
  console.log('I render again Masonery')

  const width = useWidth()

  const widthRow = {
    xl: props.xl || props.lg || props.md || props.sm || props.xs,
    lg: props.lg || props.md || props.sm || props.xs || props.xs,
    md: props.md || props.sm || props.xs || props.lg || props.xl,
    sm: props.sm || props.xs || props.md || props.lg || props.xl,
    xs: props.xs || props.sm || props.md || props.lg || props.xl,
  }

  const nbCol = widthRow[width] || 6
  return <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
    {Array.apply(null, { length: nbCol }).map((xxx, numNew) => (
      <Grid key={'Masonery_' + props.mykey + '_' + numNew} item style={Object.assign({
        width: 'calc(100% / ' + nbCol + ' )',
        margin: 0,
        padding: 0
      }, props.style || {})}>
        {
          props.datas.filter((d, i) => i % nbCol === numNew).map((d, i) => props.component(d, i))
        }
      </Grid>
    ))
    }
  </Grid>
})



// WEBPACK FOOTER //
// ./app/Components/Masonery.js